import { createSelector } from 'reselect';
import isNil from 'lodash/isNil';
import { SPRINT } from '../../../model/constants.tsx';
import { GlobalIssueCreateType } from '../../../model/modals/types.tsx';
import { projectIdSelector } from '../app/index.tsx';
import { getAppliedLabelFilters, getMostRecentAssigneeFilter } from '../card-create/index.tsx';
import { getCardLists } from '../cards/index.tsx';
import { getOpenModalData } from '../modals/index.tsx';

export const getPrefilledFieldsFromInputs = createSelector(
	[
		getOpenModalData,
		getCardLists,
		projectIdSelector,
		getAppliedLabelFilters,
		getMostRecentAssigneeFilter,
	],
	(modalData, cardLists, projectId, appliedLabels, assignee) => {
		if (
			isNil(modalData) ||
			modalData?.type !== GlobalIssueCreateType ||
			isNil(modalData?.payload)
		) {
			return null;
		}
		const { cardSummary, cardTypeId, rankBeforeCardId, cardParentId, cardListId, fixVersions } =
			modalData.payload;
		const parentIssueId =
			// parentId is 0 when 'issues without epic' filter is selected
			!isNil(cardParentId) && cardParentId !== 0 ? String(cardParentId) : '';
		const destination = cardLists[cardListId]?.type;
		return {
			projectId: String(projectId),
			issueType: String(cardTypeId),
			summary: cardSummary,
			labels: appliedLabels || [],
			assignee: assignee?.id || '',
			parentIssueId,
			fixVersions,
			sprintId: destination === SPRINT ? cardListId : undefined,
			context: {
				rankBeforeCardId: !isNil(rankBeforeCardId) ? String(rankBeforeCardId) : null,
				destination,
			},
		};
	},
);

export const getSessionIdFromInputs = createSelector(
	[getOpenModalData],
	(modalData): string | undefined => {
		if (
			isNil(modalData) ||
			modalData?.type !== GlobalIssueCreateType ||
			isNil(modalData?.payload)
		) {
			return undefined;
		}
		return modalData?.payload?.sessionId || undefined;
	},
);

export const getSubmitErrorMessage = createSelector([getOpenModalData], (modalData) => {
	if (isNil(modalData) || modalData?.type !== GlobalIssueCreateType || isNil(modalData?.payload)) {
		return undefined;
	}
	return modalData.payload.submitErrorMessage;
});
